import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Header from "../../../component/Header";
// COMMENTED OUT: Profile and subscription imports removed as per requirements
// import {
//   getActiveSubscriptionPlan,
//   getSubscriptions,
//   profileDetails,
// } from "../../../redux/Actions";
import { changeActiveHeader } from "../../../redux/Reducers/GeneralReducer";
import { strings, paths } from "../../../utils/constants";
// COMMENTED OUT: Subscription reducer import removed as per requirements
// import { onFreeTrial } from "../../../redux/Reducers/UserSubscriptionReducer";
// COMMENTED OUT: EmailDialog removed as no user validation needed


const Dashboard = () => {
  const { t } = useTranslation();
  // const { language } = useSelector((state) => state.generalReducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // COMMENTED OUT: Email dialog state removed as no user validation needed
  // const [emailDialogShow, setEmailDialogShow] = useState(false);

  const helpCard = [
    {
      icon: "../../../assets/images/bank-building-icon.svg",
      title: t(strings.translate.LIBRARY),
      intro: t(strings.translate.LIBRARY_CARD_INTRO),
      points: [
        t(strings.translate.LIBRARY_CARD_POINT_1),
        t(strings.translate.LIBRARY_CARD_POINT_2),
        t(strings.translate.LIBRARY_CARD_POINT_3),
      ],
      redirect: paths.userRoutes.SEARCH_FORM,
      label: strings.navigationHeader.user.LIBRARY,
      newlink: false
    },
    {
      icon: "../../../assets/images/edit-box-icon.svg",
      title: t(strings.translate.ADA_CARD_TITLE),
      desc1_title: "Autofill",
      desc1: " - " + t(strings.translate.ADA_CARD_DSC_1),
      desc2_title: "Rebalance Assist",
      desc2: " - " + t(strings.translate.ADA_CARD_DSC_2),
      desc3_title: "Advanced Search",
      desc3: " - " + t(strings.translate.ADA_CARD_DSC_3),
      redirect: paths.userRoutes.ACCESS_ADA,
      label: strings.navigationHeader.user.ACCESS_ADA,
      newlink: false
    },
    // COMMENTED OUT: Demos & Training box removed as per image requirements
    // {
    //   icon: "../../../assets/images/online-learning-icon.svg",
    //   title: t(strings.translate.DEMO_TRAINING),
    //   desc1: t(strings.translate.DEMO_TRAINING_CARD_DSC_1),
    //   desc2: "",
    //   desc3: "",
    //   redirect: paths.userRoutes.DEMO_TRAINING,
    //   label: strings.navigationHeader.user.DEMO_TRAINING,
    //   newlink: true
    // },
  ];

  // COMMENTED OUT: Profile, subscription, and billing API calls removed as per requirements
  // const getProfile = async () => {
  //   const data = await dispatch(
  //     profileDetails({ language: language, isAdmin: false })
  //   );
  //   return data;
  // };

  // const activePlan = async () => {
  //   const activePlan = await dispatch(
  //     getActiveSubscriptionPlan({ language: language })
  //   );
  //   if (activePlan.payload?.success) {
  //     if (!activePlan.payload.data?.isFreeUsed) {
  //       dispatch(onFreeTrial(true));
  //     } else {
  //       dispatch(onFreeTrial(false));
  //     }
  //   } else {
  //     dispatch(onFreeTrial(true));
  //   }
  // };

  // const getSubscriptionPlans = async () => {
  //   await dispatch(getSubscriptions({ language: language }));
  // };

  // const checkToken = async () => {
  //   const data = await getProfile();
  //   if (data.payload?.success) {
  //     if (!data.payload.data?.userExist) {
  //       setEmailDialogShow(true);
  //     }
  //   }
  //   activePlan();
  //   getSubscriptionPlans();
  // };

  useEffect(() => {
    dispatch(changeActiveHeader("Home"));
    // COMMENTED OUT: No token checking needed - app accessible without login
    // checkToken();


  }, []);

  const helpCardClickHandler = (item) => {
    if (item.newlink === true) {
      window.open(item.redirect, '_blank')
    }
    else {
      dispatch(changeActiveHeader(item.label));
      navigate(item.redirect);


    }

  };
  return (
    <body>
      <div>
        <Header />
      </div>
      <section className="banner-section">
        <div className="container">
          <h1 className="font-lato_bold font-26 fg-white-80 col-xl-5">
            <p>{t(strings.translate.HOME_TITAL_TEXT_PART1)}</p>
            <p>{t(strings.translate.HOME_TITAL_TEXT_PART2)}</p>
          </h1>
        </div>
      </section>
      <section className="how-we-help">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12">
              <h2 className="text-center font-lato_bold font-26 fg-primary mb-4">
                {t(strings.translate.HOW_MAY_WE_HELP)}
              </h2>
            </div>
            {helpCard.map((item, index) => (
              <div
                key={`${item.title}` + index}
                onClick={helpCardClickHandler.bind(this, item)}
                style={{ cursor: "pointer" }}
                className="col-md-6 col-lg-4 mb-4 mb-lg-0"
              >
                <div
                  className="card"
                  style={{
                    border: "1px solid #e5e5e5",
                    borderRadius: "10px",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-5px)";
                    e.currentTarget.style.boxShadow =
                      "0 10px 25px rgba(0, 0, 0, 0.1)";
                    e.currentTarget.style.borderColor = "#184437";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "none";
                    e.currentTarget.style.borderColor = "#e5e5e5";
                  }}
                >
                  <div className="d-flex align-items-center mb-3">
                    <div className="card-icon me-3" style={{ marginBottom: 0 }}>
                      <img
                        src={item.icon}
                        width="64"
                        height="35"
                        className="img-fluid"
                        alt="Search Forms"
                      />
                    </div>
                    <div className="card-title mb-0">
                      <h3 className="fg-primary font-22 font-lato_black mb-0">
                        {item.title}
                      </h3>
                    </div>
                  </div>
                  <div className="card-content fg-gray-30">
                    {item.points ? (
                      <>
                        {item.intro && (
                          <p className="font-18 font-lato line-height-2">
                            {item.intro}
                          </p>
                        )}
                        <ul className="font-18 font-lato line-height-2 ps-3 mb-0">
                          {item.points.map((point, pointIndex) => (
                            <li key={pointIndex}>{point}</li>
                          ))}
                        </ul>
                      </>
                    ) : (
                      <>
                        <p className="font-18 font-lato line-height-2">
                          {item.desc1_title && <span><b>{item.desc1_title}</b></span>}
                          <span>{item.desc1}</span>
                        </p>
                        {item.desc2 && (
                          <p className="font-18 font-lato line-height-2">
                            {item.desc2_title && <span><b>{item.desc2_title}</b></span>}
                            <span>{item.desc2}</span>
                          </p>
                        )}
                        {item.desc3 && (
                          <p className="font-18 font-lato line-height-2">
                            {item.desc3_title && <span><b>{item.desc3_title}</b></span>}
                            <span>{item.desc3}</span>
                          </p>
                        )}
                      </>
                    )}
                  </div>
                  <div className="card-link text-end">
                    <Link
                      to={item.redirect}
                      target={item.newlink === true ? "_blank" : "_self"}
                    >
                      <img
                        src="../../../assets/images/right-arrow.svg"
                        width="24"
                        height="16"
                        alt="right-arrow"
                        className="img-fluid"
                      />
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* COMMENTED OUT: EmailDialog removed as no user validation needed */}
      {/* {emailDialogShow && (
        <EmailDialog
          isOpen={emailDialogShow}
          clickHandler={() => {
            setEmailDialogShow(false);
            checkToken();
          }}
        />
      )} */}
    </body>
  );
};

export default Dashboard;
